import type { ReferencedTweetSummaryAuthorBasicInfo } from './referencedTweetSummaryAuthorBasicInfo';
import type { ReferencedTweetSummaryAuthorSocial } from './referencedTweetSummaryAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type ReferencedTweetSummaryAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: ReferencedTweetSummaryAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: ReferencedTweetSummaryAuthorSocial;
};
